import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import identityDetails from '../../../../../graphql/fragments/identity/identityDetails';
import photoAttributionDetails from '../fragments/photoAttributionDetails';
import albumMembershipGroupPurchaseDetails from '../fragments/albumMembershipGroupPurchaseDetails';
import { PhotoUrlTypeFields } from '../../../../../../../graphql/fragments/album';
import {
  PhotoForegroundDetails,
  PhotoWallpaperWatermarkDetails,
} from '../../../../../../../graphql/fragments/photo';

export const getAlbumMembershipGroupWithAllPhotosQuery = gql`
  query getAlbumMembershipGroupWithAllPhotos(
    $id: RecordID!
    $album_folder_id: RecordID
    $limit: Int = 50
    $offset: Int = 0
    $album_folder_tag_ids: [RecordID]
  ) {
    albumMembershipGroup(
      id: $id
      root_groups_only: true
      include_matched_photos_only: true
    ) {
      id
      album_memberships_has_all_photos_access(use_all_photos_mode: true)
      all_photos(
        slice: { limit: $limit, offset: $offset }
        album_folder_tag_ids: $album_folder_tag_ids
        use_all_photos_mode: true
      ) {
        total
        count
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            url
            size_code
            width
            height
          }
          attribution {
            ...photoAttributionDetails
          }
          albums(slice: { limit: 1 }) {
            records {
              id
              name
              album_type
              album_subtype
              logo_image {
                id
              }
            }
          }
          share_blocked
          price_album_folder_tag {
            ... on IRecord {
              id
            }
            ... on IAlbumFolderTag {
              name
              type
              is_pricing_tag
              digital_downloads_enabled
              digital_downloads_price {
                value
                currency
              }
            }
          }
          watermarked_urls {
            ...PhotoUrlTypeFields
          }
          ...PhotoWallpaperWatermarkDetails
          ...PhotoForegroundDetails
        }
      }
      identities {
        identity {
          ...identityDetails
        }
        matched_photos_extended {
          total
        }
        has_purchased_subscription
      }
      ...albumMembershipGroupPurchaseDetails
    }
  }
  ${identityDetails}
  ${photoAttributionDetails}
  ${albumMembershipGroupPurchaseDetails}
  ${PhotoUrlTypeFields}
  ${PhotoWallpaperWatermarkDetails}
  ${PhotoForegroundDetails}
`;

const getAlbumMembershipGroupWithAllPhotosOptions = {
  options: ({ albumMembershipGroupId, albumMembershipGroupFilters }) => ({
    variables: {
      id: albumMembershipGroupId,
      album_folder_tag_ids: albumMembershipGroupFilters,
    },
    fetchPolicy: 'cache-first',
  }),
  skip: ({ albumMembershipGroupId }) => !albumMembershipGroupId,
};

const getAlbumMembershipGroupWithAllPhotos = graphql(
  getAlbumMembershipGroupWithAllPhotosQuery,
  getAlbumMembershipGroupWithAllPhotosOptions,
);

export default getAlbumMembershipGroupWithAllPhotos;
